import axios from 'axios';

/**
 * Axios-Client fuer die Auth-API (`/api/auth`). nginx leitet `/api/*` an den
 * api-service weiter. Erfolgsantworten haben die Form `{ token, user }`.
 */
const authApi = axios.create({
  baseURL: '/api/auth',
  timeout: 15000,
});

const TOKEN_KEY = 'auth_token';
const USER_KEY = 'auth_user';

// ── LocalStorage-Helfer (zentral, damit Slice und Interceptor dieselben Keys nutzen) ──
export const ladeToken = () => localStorage.getItem(TOKEN_KEY);

export const ladeUser = () => {
  const roh = localStorage.getItem(USER_KEY);
  return roh ? JSON.parse(roh) : null;
};

export const speichereAuth = ({ token, user }) => {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(USER_KEY, JSON.stringify(user));
};

export const loescheAuth = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
};

// ── Requests ──
export const loginApi = (username, password) =>
  authApi.post('/login', { username, password }).then((r) => r.data);

export const registerApi = (username, email, password) =>
  authApi.post('/register', { username, email, password }).then((r) => r.data);

// JWT-geschuetzt: nur der angemeldete Nutzer kann sein eigenes Passwort aendern.
export const changePasswordApi = (currentPassword, newPassword) =>
  authApi
    .post(
      '/change-password',
      { currentPassword, newPassword },
      { headers: { Authorization: `Bearer ${ladeToken()}` } }
    )
    .then((r) => r.data);

export default authApi;
